import { render, staticRenderFns } from "./PreorderForm.vue?vue&type=template&id=b555b20a"
import script from "./PreorderForm.vue?vue&type=script&lang=ts"
export * from "./PreorderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports